module.exports = __webpack_public_path__ + "img/jacket_thumb.fc8e7aa2.png";